<template lang="html">
    <span class="stt"><i class="fas fa-chevron-up"></i></span>
</template>

<script>
export default {
    name: 'Stt',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
        $(document.body).on('click','.stt',function(){
            $('html, body').animate({
                scrollTop: 0
            }, 500, function() {
            });

            return false;
        });

        $(window).scroll(function() {

            var distanta = $(document).scrollTop();

            if(distanta > 100) {
                $(".stt").show();
            }
            else {
                $(".stt").hide();
            }
        });
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.stt {
    position: fixed;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    background: #aaa;
    opacity: 0.6;
    bottom: 12px;
    right: 10px;
    z-index: 1005;
    cursor: pointer;
    display: none;
    font-size: 35px;
    padding-top: 5px;
    text-align: center;
    padding-left: 2px;
    color: #fff;
    border: solid 1px #fff;
}

</style>
